<template>
	<router-view
		@reload="reload"
		:user="user"
		:isAuth="isAuth">
		</router-view>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/notifications/layout/Notifications.vue